<template>
  <div class="page-title">
    使用者條款
  </div>
  <div class="page-container">
    <div class="content">
      歡迎使用 CHW Watch (以下簡稱「本應用程式」)。在使用本應用程式前，請仔細閱讀下列使用者條款。使用本應用程式即表示您同意遵守本條款。<br/>
      <br/>
      <span class="sub-title">1. 服務內容</span><br/>
      本應用程式提供即時水資源監測、警報通知、設備數據管理與報表功能，用於協助用戶有效管理水資源，並透過自訂警報標準與歷史數據統計功能，讓使用者能全面掌控水資源狀態。<br/>
      <br/>
      <span class="sub-title">2. 使用者責任</span><br/>
      使用者需提供準確且完整的個人資料以註冊帳號，並確保資料的即時更新。<br/>
      禁止未經授權的資料篡改、入侵或逆向工程本應用程式，包含但不限於程式碼破解與數據竄改。<br/>
      使用者需自行負責其帳號的安全與活動，並妥善保管登入資訊，如有異常活動，應立即通知我們。<br/>
      <br/>
      <span class="sub-title">3. 智慧財產權</span><br/>
      本應用程式中包含的所有內容、圖像、技術與設計均為「好事創新」之智慧財產，未經書面許可不得複製、修改、散佈或以其他形式使用。<br/>
      <br/>
      <span class="sub-title">4. 服務限制與變更</span><br/>
      本公司保留隨時變更、暫停或終止本應用程式部分或全部功能的權利，恕不另行通知。<br/>
      若因系統維護或其他不可抗力因素導致服務暫停，我們將盡力提前通知使用者。<br/>
      <br/>
      <span class="sub-title">5. 第三方服務</span><br/>
      本應用程式可能包含連結至第三方服務或內容，這些第三方服務由其各自的營運商負責。本公司對於第三方服務的準確性、可靠性或合規性不負任何責任。<br/>
      <br/>
      <span class="sub-title">6. 責任限制</span><br/>
      本應用程式僅作為水資源管理輔助工具，對於因數據誤差、設備故障或其他不可控因素所導致的任何直接或間接損失，本公司概不負責。<br/>
      <br/>
      <span class="sub-title">7.使用者資料保護</span><br/>
      使用者的個人資料將依據隱私權條款進行保護與管理，詳情請參閱本應用程式的隱私權條款。<br/>
      <br/>
      <span class="sub-title">8. 準據法與爭議處理</span><br/>
      本條款受中華民國法律管轄，如有任何爭議，雙方應以台灣台北地方法院為第一審管轄法院。<br/>
      <br/>
      <span class="sub-title">9. 聯繫方式</span> 若有任何問題或需要協助，請聯繫：<br/>
      公司名稱：「好事創新」<br/>
      電子郵件：isonitccs@gmail.com<br/>
    </div>
  </div>
</template>

<style scoped>

.page-title {
  background-color: blue;
  margin: 0;
  padding: 38px 0;
  font-size: 24px;
  font-weight: bold;
  color: white;
  text-align: center;
}

.page-container {
  display: flex;
  justify-content: center;
}

.content {
  background-color: white;
  width: fit-content;
  padding: 40px 50px;
}

.sub-title {
  font-weight: bold;
}
</style>
